/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps, import/no-unresolved */
import React, { useState } from 'react';
import { PromoHeader, PromoContent, PromoMobileContent, PromoWarning } from 'assets/components';

const Promo = () => {
  const [isWarningVisible, setIsWarningVisible] = useState(true);
  const isUSA = window.location.hostname === process.env.REACT_APP_US_FE_BASE_HOSTNAME;

  return (
    <>
      <div className="d-none d-md-flex flex-column w-100 h-100">
        {isWarningVisible && <PromoWarning setIsWarningVisible={setIsWarningVisible} />}
        <div className="d-flex flex-column align-items-center w-100 h-100 promo-main">
          <PromoHeader />
          <PromoContent isUSA={isUSA} />
        </div>
      </div>
      <div className="d-flex d-md-none flex-column position-relative promo-main-mobile">
        {isWarningVisible && <PromoWarning setIsWarningVisible={setIsWarningVisible} />}
        <PromoMobileContent isUSA={isUSA} />
      </div>
    </>
  );
};

export default Promo;
